// Utility function to format the public key
export const formatPublicKey = (key: string | null, begin: number = 2, end: number = 4): string => {
  if (!key) return ""
  return `${key.slice(0, begin)}...${key.slice(-end)}`
}

export const formatSolBalance = (str: string | undefined, cnt: number = 3): string => {
  if (!str) return ""
  const balance = parseFloat(str)
  return balance.toFixed(cnt)
}
